/**
 * DESO-owned browser paths (feat-201). Conversation CRUD, compose, events,
 * and notifications stay on the EPS BFF baseUrl.
 *
 * Keep webpack.dev.js BFF_INGRESS=feat-201 matches in sync with this list.
 */

function pathnameOf(path: string): string {
  const withoutQuery = path.split('?')[0] ?? path;
  return withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
}

export function isFrontdoorPath(path: string): boolean {
  const pathname = pathnameOf(path);
  if (pathname === '/converse' || pathname.startsWith('/converse/')) {
    return true;
  }
  if (/^\/conversations\/[^/]+\/status\/stream$/.test(pathname)) {
    return true;
  }
  if (pathname === '/style-preferences' || pathname.startsWith('/style-preferences/')) {
    return true;
  }
  return false;
}
